<template>
  <v-card class="mx-8 my-6 pb-4" :style="cardClass" elevation="0">
    <div class="d-flex justify-center flex-column">
      <v-alert color="#D4022A" dark type="error" border="left" id="attention">
        ATTENTION! This tablet still needs to be physically checked in on the
        device.
      </v-alert>
      <div class="d-flex justify-center" id="understand">
        <v-checkbox v-model="understand"></v-checkbox>
        <span class="mt-5"
          >I understand this device still needs to be physically checked in on
          the devices</span
        >
      </div>
    </div>
    <div class="d-flex justify-center">
      <v-btn
        :disabled="!understand"
        color="black"
        class="mt-4"
        style="color:white;"
        @click="submit"
        id="submit-button"
        >Submit</v-btn
      >
    </div>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import ReconciliationDetailData from '@/mixins/ReconciliationDetailData';
import { MobileView } from '@/mixins';
import card from '@/mixins/card';

export default {
  mixins: [ReconciliationDetailData, MobileView, card],
  data: () => ({
    understand: false,
  }),
  methods: {
    ...mapActions({
      _uploadDetails: 'reconciliationDetails/uploadDetails',
    }),
    submit() {
      this._uploadDetails(this.details);
    },
  },
  computed: {
    cardClass() {
      if (this.showMobileView) {
        return 'overflow:hidden;';
      }
      return 'width:50%; overflow:hidden;';
    },
  },
};
</script>

<style></style>
